<mat-toolbar class="dark" [@openClose]="scrollState" [class.mat-elevation-z8]="scrollState == 'visible'" cdkScrollable>
    <img routerLink="/" class="logo" src="../../../assets/images/Artworxx_logo_Simple_Creative-avatar.png" i18n-alt alt="artworxx avatar ikon">
    <span class="push-spacer"></span>
    <button mat-button *ngFor="let item of menu" i18n>{{ item.title }}</button>
    <!-- locale -->
    <button mat-button [matMenuTriggerFor]="languageSelect"><mat-icon>language</mat-icon>HU</button>
    <mat-menu #languageSelect="matMenu">
        <button mat-menu-item i18n>Magyar</button>
    </mat-menu>
</mat-toolbar>